import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Box } from '../Elements'
import { Phone, Logo, LogoAr, ArrowBtn, ArrowBtnWhite } from '../AllImages'
import { Container, Row } from 'react-bootstrap'
import { ButtonWithIcon, ContactButtonHref, ContactButtonHref2 } from '../CustomElements'
import { scroller } from "react-scroll";

import { Link } from 'react-scroll'
import { useTranslation } from 'react-i18next'
import { BsJustify, BsX } from "react-icons/bs"
import { useNavigate } from 'react-router-dom'
import { Linkedin } from 'react-bootstrap-icons'
import LangChangeButton from '../../Languages/LangChangeButton'
import { NavDataConfig } from './HeaderData'
import i18n from '../../Languages/INEXT'
import PricingModal from '../../components/pricingmodal/PricingModal'
const Header = () => {
    const navigate = useNavigate()
    const WhatsApp = () => {
        const phoneNumber = '+966567974344';
        const message = 'Hello, this is Soola';
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };
    const { t } = useTranslation();
    const [isSticky, setIsSticky] = useState(false);
    const [toggle, setToggle] = useState(false);
    const navRef = useRef(null);
    const [showModal, setShowModal] = useState(false);

    const handleToggle = () => {
        setToggle(!toggle);
        const element = document.querySelector(".nav-bar-list");
        element.classList.toggle("showToggle");
    };
    const scrollToPricing = () => {
        scroller.scrollTo("pricing", {
            duration: 500,
            delay: 0,
            smooth: "easeInOutQuart",
            offset: -99,   // same offset as your menu
        });
        
    };
    // closeMenu
    const closeMenu = () => {
        if (navRef.current) navRef.current.classList.remove('showToggle');
        setToggle(false);
    };
    const handlePricingClick = () => {
        // handleToggle();       // close mobile menu
        scrollToPricing();    // then scroll to pricing
        closeMenu();
    };

    const handlePricingModal = () => {
        setShowModal(true);
    }
    

    
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 1) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <>
            <HeaderContainer className={`${isSticky ? 'sticky' : ''} container-fluid`}>
                <Container>
                    <Row>
                        <Box className='nav-bar'>
                            <Box className='logoHeader' onClick={() => navigate('/')}>
                                {i18n.language === "ar" ? <LogoAr /> : <Logo />}
                            </Box>
                            
                            <Box className='d-flex align-items-center headerBtnsContainer'>
                                {/* <Box className='d-flex align-items-center socialLinksContainer'>
                                    <Box className='socialLinks'><Snapchat onClick={SocialLinkSnap} /></Box>
                                    <Box className='socialLinks'><LinkedIn onClick={SocialLinkLinkedIn} /></Box>
                                    <Box className='socialLinks'><Instagram onClick={SocialLinkInstagram} /></Box>
                                    <Box className='socialLinks'><Twitter onClick={SocialLinkTwitter} /></Box>
                                </Box> */}
                                <Box className='nav-bar-list'  ref={navRef}>
                                    {NavDataConfig.map((item, key) => {
                                        return (
                                            <Box key={key}>
                                                {item.label === "Pricing" ? (
                                                    <Link to={item.to} spy={true} smooth={true} offset={-99} duration={500} activeClass="active" onClick={handlePricingModal}>{t(item.label)}</Link>
                                                ) : (
                                                    <Link to={item.to} spy={true} smooth={true} offset={-99} duration={500} activeClass="active" onClick={handleToggle}>{t(item.label)}</Link>
                                                )}
                                            </Box>
                                        )
                                    })}
                                    <ContactButtonHref2 href='https://web.officely.one/login' target="_blank" icon={ArrowBtn} label={t('SignIn')} className="logSign logSignMobile"  onClick={closeMenu} />
                                    <ContactButtonHref className="logSign logSignMobile" icon={ArrowBtnWhite} label={t('SignUpFree')} bg="var(--secondaryColor)" color="var(--white)"  onClick={handlePricingClick} />
                                </Box>
                                <ContactButtonHref2 href='https://web.officely.one/login' target="_blank" icon={ArrowBtn} label={t('SignIn')} className="logSign logSignDesktop" />
                                <ContactButtonHref className="logSign logSignDesktop" icon={ArrowBtnWhite} label={t('SignUpFree')} bg="var(--secondaryColor)" color="var(--white)"  onClick={handlePricingModal} />
                                {/* <ButtonWithIcon className="headerWhatsapp" border="1px solid var(--secondaryColor)" padding='11px 24px' radius="24px" icon={Phone} label='+966 56 797 4344' onClick={WhatsApp} /> */}
                                <LangChangeButton color="var(--secondaryColor)" iconColor="var(--secondaryColor)" />
                                <span className="toggleBtn" onClick={handleToggle}>
                                    {toggle ? <BsX size={30} /> : <BsJustify size={30} />}
                                </span>
                            </Box>
                        </Box>
                    </Row>
                </Container>
                <PricingModal
                    show={showModal}
                    handleClose={() => setShowModal(false)}
                />
            </HeaderContainer>
        </>
    )
}
const HeaderContainer = styled.header`
    -webkit-transition: all .3s ease-out 0s;
    transition: all .3s ease-out 0s;
    background: transparent;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    width: 100%;
    padding-top: 24px;
    padding-bottom: 24px;
    .logo{
        cursor:pointer;
    }
    .socialLinks{
        cursor: pointer;
    }
    .socialLinksContainer{
        display: flex;
        gap: 16px;
    }
    .nav-bar{
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-between;
    }
    .nav-bar-list{
        display:flex;  
        align-items: center;
        gap: 5px;
    }
    .logSign{
        cursor: pointer;
    }
    .nav-bar-list a{
        color:var(--textDark);
        padding: 0px 17px;
        line-height: 48px;
        position: relative;
        font-size:16px;
        font-family: var(--medium);
        border-radius: 12px;
        display: block;
        cursor: pointer;
        white-space: nowrap;
        &:hover{
            background: var(--themeColor);
            font-family: var(--medium);
            color:var(--white);
        }
        &:focus, &.active{
            background: var(--themeColor);
            font-family: var(--medium);
            color:var(--white);
        }
        
    }
    .headerBtnsContainer{
        gap: 16px;
    }
    .logSignMobile{
        display: none !important;
    }
    
    body.rtl &{
        .nav-bar-list a{
            font-family: var(--arRegular);
            &:hover{
                font-family: var(--arRegular);
            }
            &:focus, &.active{
                font-family: var(--arBold);
            }
        }
    }
    @media (max-width: 1299px) {
        .nav-bar-list {
            gap: 1px;
        }
        .headerBtnsContainer {
            gap: 10px;
        }
    }
    @media (max-width: 1199px) {
        .nav-bar-list{
            gap: 1px;
            a{
                padding: 0px 10px;
            }
        }
        .headerBtnsContainer{
            gap: 5px;
        }
        .headerWhatsapp button{
            padding: 11px 15px;
        }
    }
    @media (max-width: 1099px) {
        background: var(--bg2);
        
        .nav-bar-list{
            a{
                padding: 2px 25px;
            }
        }
        .logSign{
            a{
                gap: 2px;
            }
        }
        body.rtl &{
            .logSignDesktop{
                a{
                    span{
                        font-size: 15px;
                    }
                }
            }
        }

        
    }
    @media (max-width: 767px) {
        
        .socialLinksContainer{
            display: none !important;
        }
        .nav-bar-list{
            a{
                padding: 2px 20px;
            }
        }
    }
    @media (max-width: 640px) {
        padding-top: 15px;
        padding-bottom: 15px;
        .socialLinksContainer{
            gap: 8px;
        }
        .logoHeader{
            svg{
                width: fit-content !important; 
                height: 26px;
            }
        }
    }
    @media (max-width: 550px) {
        .socialLinksContainer{
            display: none !important;
        }
        .logoHeader{
            /* width: 130px; */
            svg{
                width: fit-content !important; 
                height: 26px;
            }
        }
        .logSign{
            a{
                gap: 2px;
                padding: 12px 5px 12px 10px;
            }
        }
        body.rtl &{
            .logSign{
                a{
                    padding-right: 10px;
                    padding-left: 5px;
                }
            }
        }
    }
    @media (max-width: 450px) {
        .logSignDesktop{
            display: none !important; 
        }
        .logSignMobile{
            display: flex !important; 
            a{
                display: flex;
                background-color: var(--white);
                justify-content: space-between;
                padding: 0px 20px;
                
                svg{
                    [stroke] {
                        stroke: var(--textDark);
                    }
                    [fill] {
                        fill: var(--textDark);
                    }
                }
                &:hover{
                    box-shadow: none;
                    svg{
                        [stroke] {
                            stroke: var(--white);
                        }
                        [fill] {
                            fill: var(--white);
                        }
                    }
                }
            }
        }
        body.rtl &{
            .logSign{
                a{
                    padding-right: 20px;
                    padding-left: 20px;
                }
            }
        }
        &.sticky .showToggle,  & .showToggle{
            top: 72px;
        }
    }
    @media (max-width: 390px) {
        .headerWhatsapp{
            display: none !important;
        }
    }
`
export default Header
